module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"title1":"윤리규범","title2":"윤리규범 실천지침","title3":"상담 및 제보","ethical_management":"윤리경영"},"en":{"title1":"Code of Ethics","title2":"Code of Ethics Practice Guidelines","title3":"Consultation and Reporting","ethical_management":"Ethical Management"},"ja":{}}')
  delete Component.options._Ctor
}
